import { motion } from "framer-motion";
import { IMAGES } from "@/data/site";

const captions = [
  "Rianimazione cardiopolmonare",
  "Lezioni in aula",
  "Defibrillatore DAE",
  "Formazione sul campo",
];

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-end justify-between mb-12">
          <h2 className="font-heading font-bold text-4xl md:text-6xl tracking-tighter text-brand-black leading-none">
            In aula   e sul campo
          </h2>
          <div className="hidden md:block text-xs uppercase tracking-[0.25em] text-brand-ink">
            @treffe.formazione
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {IMAGES.gallery.map((src, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className={`group relative overflow-hidden bg-brand-black ${
                i % 3 === 0 ? "lg:mt-10" : ""
              }`}
            >
              <img
                src={src}
                alt={captions[i]}
                className="w-full h-64 md:h-80 object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">
                {captions[i]}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
